export class NoAccessError extends Error {
  constructor(message = 'You do not have access to this resource.') {
    super(message)
    this.name = 'NoAccessError'
  }
}
